const actions = {
  async getCampaignCategories ({ commit }) {
    const response = await window.axios.get('/recommendations/get/industries')

    commit('SET_CAMPAIGN_CATEGORIES', response.data.payload)
  },
  async getGenders ({ commit }) {
    const response = await window.axios.get('/recommendations/get/genders')

    commit('SET_GENDERS', response.data.payload)
  },
  async getTargetDevices ({ commit }) {
    const response = await window.axios.get('/recommendations/get/devices')

    commit('SET_TARGET_DEVICES', response.data.payload)
  },
  async getAgeGroups ({ commit }) {
    const response = await window.axios.get('/recommendations/get/age-groups')

    commit('SET_AGE_GROUPS', response.data.payload)
  },
  async getAdvertisingChannels ({ commit }) {
    const response = await window.axios.get('/recommendations/get/advertising_channels')

    commit('SET_ADVERTISING_CHANNELS', response.data.payload.map((item) => {
      if (+item.enabled === true) {
        return {
          id: item.id,
          title: item.title,
          subtitle: item.description,
          image: item.icon_url,
          supports_audience_creation: item.supports_audience_creation,
          supports_native_publisher_targeting: item.supports_native_publisher_targeting,
          supports_location_targeting: item.supports_location_targeting,
          supports_native_category_targeting: item.supports_native_category_targeting,
          supports_device_targeting: item.supports_device_targeting,
          supports_gender_targeting: item.supports_gender_targeting,
          supports_frequency_capping_targeting: item.supports_frequency_capping_targeting,
          supports_age_range_targeting: item.supports_age_range_targeting,
          supports_budget_optimizing_for_impressions: item.supports_budget_optimizing_for_impressions,
          supports_budget_optimizing_for_clicks: item.supports_budget_optimizing_for_clicks,
          supports_adset_delivery_type: item.supports_adset_delivery_type,
          supports_content_category_insights: item.supports_content_category_insights,
          supports_domains_insights: item.supports_domains_insights,
          supports_update_landing_page_url: item.supports_update_landing_page_url,
          supports_update_image: item.supports_update_image,
          supports_update_targeting: item.supports_update_targeting,
          supports_pixel: item.supports_pixel,
          supports_meta_detailed_targeting: item.supports_meta_detailed_targeting,
          supports_traffic_estimate: item.supports_traffic_estimate,
          supports_reach_estimate: item.supports_reach_estimate
        }
      }
    }))
  },
  async getObjectives ({ commit }) {
    const response = await window.axios.get('/recommendations/get/objectives')

    commit('SET_OBJECTIVES', response.data.payload.map((item) => {
      if (+item.is_active === 1) {
        return {
          id: item.id,
          title: item.display_name,
          subtitle: item.description,
          image: item.icon,
          minAllowedBudget: item.min_daily_budget
        }
      }
    }))
  },
  async getDisplayTypes ({ commit }) {
    const response = await window.axios.get('/recommendations/get/display_types')

    commit('SET_DISPLAY_TYPES', response.data.payload.map((item) => {
      return {
        id: item.id,
        title: item.display_name,
        subtitle: item.description,
        image: item.icon
      }
    }))
  },
  async getRejectReviewReasons ({ commit }) {
    const response = await window.axios.get('/recommendations/get/review_reasons', {
      params: {
        type: 'reject'
      }
    })

    commit('SET_REJECT_REVIEW_REASONS', response.data.payload)
  },
  async getHoldReviewReasons ({ commit }) {
    const response = await window.axios.get('/recommendations/get/review_reasons', {
      params: {
        type: 'hold'
      }
    })

    commit('SET_HOLD_REVIEW_REASONS', response.data.payload)
  },

  async deleteCampaign ({commit}, campaign) {
    await window.axios.delete(`/campaigns/delete/${campaign.id}`)

    commit('SET_DELETED_CAMPAIGN', campaign)
  },

  async getAccountCampaigns ({commit}, filters) {
    const response = await window.axios.get('/campaigns/get-user-account-campaigns-without-full-details', {
      params: {
        include_children: false,
        ...filters
      }
    })

    commit('SET_LOGGED_IN_ACCOUNT_CAMPAIGNS', response.data.payload)
  },

  async getTargetingLookups ({ commit }) {
    const response = await window.axios.get('/recommendations/get/lookups')

    response.data.payload.display_types = response.data.payload.display_types.map(item => ({
      id: item.id,
      advertising_channel_id: item.advertising_channel_id,
      title: item.display_name,
      subtitle: item.description,
      image: item.icon
    }))

    response.data.payload.objectives = response.data.payload.objectives.map(item => ({
      id: item.id,
      advertising_channel_id: item.advertising_channel_id,
      title: item.display_name,
      subtitle: item.description,
      image: item.icon,
      minAllowedBudget: item.min_daily_budget
    }))

    response.data.payload.advertising_channels = response.data.payload.advertising_channels.map(item => ({
      id: item.id,
      title: item.title,
      subtitle: item.description,
      image: item.icon_url,
      supports_audience_creation: item.supports_audience_creation,
      supports_native_publisher_targeting: item.supports_native_publisher_targeting,
      supports_location_targeting: item.supports_location_targeting,
      supports_native_category_targeting: item.supports_native_category_targeting,
      supports_device_targeting: item.supports_device_targeting,
      supports_gender_targeting: item.supports_gender_targeting,
      supports_frequency_capping_targeting: item.supports_frequency_capping_targeting,
      supports_age_range_targeting: item.supports_age_range_targeting,
      supports_budget_optimizing_for_impressions: item.supports_budget_optimizing_for_impressions,
      supports_budget_optimizing_for_clicks: item.supports_budget_optimizing_for_clicks,
      supports_adset_delivery_type: item.supports_adset_delivery_type,
      supports_content_category_insights: item.supports_content_category_insights,
      supports_domains_insights: item.supports_domains_insights,
      supports_update_landing_page_url: item.supports_update_landing_page_url,
      supports_update_image: item.supports_update_image,
      supports_update_targeting: item.supports_update_targeting,
      supports_pixel: item.supports_pixel,
      supports_meta_detailed_targeting: item.supports_meta_detailed_targeting,
      supports_traffic_estimate: item.supports_traffic_estimate,
      supports_reach_estimate: item.supports_reach_estimate

    }))

    commit('SET_TARGETING_LOOKUPS', response.data.payload)
  }
}

export default actions
